export const interfaceSwBranch = 'sw/swbranch/page' // 专区分会接口
export const interfaceSwtopmenu = 'sw/swtopmenu/page' // 上浮菜单
export const interfaceSwnavigationBar = 'sw/swnavigationbar/page' // 导航栏
export const interfaceSwBanner = 'sw/swcarouselmap/page' // banner
export const interfaceSwNotice = 'sw/swnotice/page' // 公告
export const interfaceSwNoticeInfo = 'sw/swnotice/' // 公告详情
export const interfaceSwLogo = 'sw/swlogo/page' // logo区域
export const interfaceSwscrollchart = 'sw/swscrollchart/page' // 图片滚动区域
export const interfaceSwadvertisement = 'sw/swadvertisement/page' // 广告
export const interfaceSwArticle = 'sw/article/page' // 栏目
export const interfaceSwArticleReadNum = 'sw/article/readNum' // 栏目
export const interfaceSwMeet = 'sw/swmeeting/page' // 会议
export const interfaceSwMeetInfo = 'sw/swmeeting' // 会议详情
export const interfaceLogin = '/strokeuser/userinfo/login' // 登录
export const interfaceRegister = '/strokeuser/userinfo/register' // 注册
export const interfaceGetSmsCode = '/strokeuser/userinfo/sendSmsCode/' // 获取验证码
export const interfaceGetUserInfo = '/strokeuser/userinfo/getUserInfo' // 获取验证码
